export default __webpack_public_path__ + "static/media/laval20.fb6772f9.jpg";